<template>
    <v-card
        width="650"
        style="box-shadow: unset !important;background: white !important; border: 1px solid lightgray;"
    >
        <v-toolbar
            dense
            flat
            dark
        >
            Change History
        </v-toolbar>
        <div
            v-if="loading"
            style="text-align:center; margin-top: 20px; margin-bottom: 20px;"
        >
            <v-progress-circular
                indeterminate
                color="blue"
            ></v-progress-circular>
            <div
                style="margin-top: 10px;font-size: smaller; color: gray;"
            >
                Querying history...
            </div>
        </div>
        <div
            v-else
        >
            <v-data-table
                :headers="headers"
                :items="records"
            >
                <template v-slot:items="props">
                    <td>
                        {{ convertToLocal(props.item.updated_at) }}<br />
                        <div
                            style="font-size: smaller; color: gray; margin-top: -5 px;"
                        >
                            by {{ props.item.updated_by_name }}
                        </div>
                    </td>
                    <td>
                        <v-chip
                            v-if="props.item.action === '+'"
                            small
                            color="green"
                            text-color="white"
                        >
                            Created
                        </v-chip>
                        <v-chip
                            v-if="props.item.action === '~'"
                            small
                            color="blue"
                            text-color="white"
                        >
                            Modified
                        </v-chip>
                        <v-chip
                            v-if="props.item.action === '-'"
                            small
                            color="red"
                            text-color="white"
                        >
                            Deleted
                        </v-chip>
                    </td>
                    <td><div style="max-height: 100px; overflow-y: scroll; overflow-wrap: break-word;">
                        <v-icon
                            v-if="props.item.status !== null"
                            left
                        >
                            {{ statusIconClass(props.item.status) }}
                        </v-icon>
                        {{ props.item.string !== "" ? props.item.string : "(empty)" }}
                    </div></td>
                </template>
            </v-data-table>
        </div>
    </v-card>
</template>

<script>
import api from '@/api'

export default {
    name: 'AnswerHistoryReview',
    props: ['questionId', 'fieldTypeId', 'userFormId', 'listId', 'focused'],
    data () {
        return {
            records: [

            ],
            headers: [
                { text: 'Updated At/By', value: 'updated_at', sortable: false, width: 70},
                { text: 'Action', value: 'action', sortable: false, width: 10, align: 'center'},
                { text: 'Value', value: 'value',  sortable: false, width: 150, align: 'left'}
            ],
            loading: false
        }
    },
    watch: {
        focused(newVal) {
            if (newVal) {
                this.fetchHistory()
            }
        }
    },
    methods: {
        fetchHistory() {
            this.loading = true
            api.userform.userForm.getHistory(
                this.userFormId, this.questionId, this.fieldTypeId, this.listId ? this.listId.id : null
            )
            .then(historyRecords => {
                this.records = historyRecords
            })
            .finally(() => {
                this.loading = false
            })
        },
        statusIconClass (status) {
            if (status === 'follow up') {
                return 'report_problem'
            } else {
                return 'check_circle'
            }
        },
    },
}
</script>

<style>
</style>